export const taxIdTypes = [
  {
    country: 'Andorra',
    alpha2: 'AD',
    type: 'ad_nrt',
    label: 'AD NRT',
    exampleFormat: 'A-123456-Z',
    regex: /^[A-Z]\-(\d{6})\-[A-Z]$/, // Starts with a letter, followed by 6 digits, and ends with a letter
  },
  {
    country: 'Argentina',
    alpha2: 'AR',
    type: 'ar_cuit',
    label: 'AR CUIT',
    exampleFormat: '20-12345678-9',
    regex: /^[0-9]{2}-[0-9]{8}-[0-9]$/, // Looks for 2 digits, a hyphen, 8 digits, another hyphen, and then 1 digit
  },
  {
    country: 'Australia',
    alpha2: 'AU',
    type: 'au_abn',
    label: 'AU ABN',
    exampleFormat: '12345678912',
    regex: /^\d{11}$/,
  },
  {
    country: 'Australia',
    alpha2: 'AU',
    type: 'au_arn',
    label: 'AU ARN',
    exampleFormat: '123456789123',
    regex: /^\d{12}$/,
  },
  {
    country: 'Austria',
    alpha2: 'AT',
    type: 'eu_vat',
    label: 'AT VAT',
    exampleFormat: 'ATU12345678',
    regex: /^ATU(\d{8})$/, // Looks for 'ATU' followed by 8 digits
  },
  {
    country: 'Belgium',
    alpha2: 'BE',
    type: 'eu_vat',
    label: 'BE VAT',
    exampleFormat: 'BE0123456789',
    regex: /^BE0?(\d{9})$/, // Looks for 'BE' followed by 9 digits, with an optional leading 0
  },
  {
    country: 'Bolivia',
    alpha2: 'BO',
    type: 'bo_tin',
    label: 'BO TIN',
    exampleFormat: '123456789',
    regex: /^(\d{9})$/, // Looks for 9 digits
  },
  {
    country: 'Brazil',
    alpha2: 'BR',
    type: 'br_cnpj',
    label: 'BR CNPJ',
    exampleFormat: '01.234.456/5432-10',
    regex: /^\D*(\d\D*){14}$/,
  },
  {
    country: 'Brazil',
    alpha2: 'BR',
    type: 'br_cpf',
    label: 'BR CPF',
    exampleFormat: '123.456.789-87',
    regex: /^\D*(\d\D*){11}$/,
  },
  {
    country: 'Bulgaria',
    alpha2: 'BG',
    type: 'bg_uic',
    label: 'BG UIC',
    exampleFormat: '123456789',
    regex: /^\D*(\d\D*){9}$/,
  },
  {
    country: 'Bulgaria',
    alpha2: 'BG',
    type: 'eu_vat',
    label: 'BG VAT',
    exampleFormat: 'BG0123456789',
    regex: /^BG0?(\d{9})$/, // Looks for 'BG' followed by 9 digits, with an optional leading 0
  },
  {
    country: 'Canada',
    alpha2: 'CA',
    type: 'ca_bn',
    label: 'CA BN',
    exampleFormat: '123456789',
    regex: /^\D*(\d\D*){9}$/,
  },
  {
    country: 'Canada',
    alpha2: 'CA',
    type: 'ca_gst_hst',
    label: 'CA GST/HST',
    exampleFormat: '123456789RT0002',
    regex: /^\D*(\d\D*){9}RT(\d\D*){4}$/,
  },
  {
    country: 'Canada',
    alpha2: 'CA',
    type: 'ca_pst_bc',
    label: 'CA PST/BC',
    exampleFormat: 'PST-1234-5678',
    regex: /^PST\-(\d\D*){8}$/,
  },
  {
    country: 'Canada',
    alpha2: 'CA',
    type: 'ca_pst_mb',
    label: 'CA PST/MB',
    exampleFormat: '123456-7',
    regex: /^(\d\D*){6}\-(\d\D*){1}$/,
  },
  {
    country: 'Canada',
    alpha2: 'CA',
    type: 'ca_pst_sk',
    label: 'CA PST/SK',
    exampleFormat: '1234567',
    regex: /^\D*(\d\D*){7}$/,
  },
  {
    country: 'Canada',
    alpha2: 'CA',
    type: 'ca_qst',
    label: 'CA QST',
    exampleFormat: '1234567891TQ0001',
    regex: /^[0-9]{10}TQ[0-9]{4}$/,
  },
  {
    country: 'Chile',
    alpha2: 'CL',
    type: 'cl_tin',
    label: 'CL TIN',
    exampleFormat: '12.345.678-K',
    regex: /^(\d{2})\.(\d{3})\.(\d{3})\-(K|\d)$/, // Looks for 2 digits, a period, 3 digits, another period, 3 digits, a hyphen, and then either 'K' or a digit
  },
  {
    country: 'China',
    alpha2: 'CN',
    type: 'cn_tin',
    label: 'CN TIN',
    exampleFormat: '123456789012345678',
    regex: /^(\d{15}|\d{18})$/, // Looks for 15 or 18 digits
  },
  {
    country: 'Colombia',
    alpha2: 'CO',
    type: 'co_nit',
    label: 'CO NIT',
    exampleFormat: '123.456.789-0',
    regex: /^(\d{3})\.(\d{3})\.(\d{3})\-(\d)$/, // Looks for 3 digits, a period, 3 digits, another period, 3 digits, a hyphen, and then a digit
  },
  {
    country: 'Costa Rica',
    alpha2: 'CR',
    type: 'cr_tin',
    label: 'CR TIN',
    exampleFormat: '1-234-567890',
    regex: /^(\d{1})\-(\d{3})\-(\d{6})$/, // Looks for 1 digit, a hyphen, 3 digits, another hyphen, and then 6 digits
  },
  {
    country: 'Croatia',
    alpha2: 'HR',
    type: 'eu_vat',
    label: 'HR VAT',
    exampleFormat: 'HR12345678912',
    regex: /^HR(\d{11})$/, // Looks for 'HR' followed by 11 digits
  },
  {
    country: 'Cyprus',
    alpha2: 'CY',
    type: 'eu_vat',
    label: 'CY VAT',
    exampleFormat: 'CY12345678Z',
    regex: /^CY(\d{8}[A-Z])$/, // Looks for 'CY' followed by 8 digits and an uppercase letter
  },
  {
    country: 'Czech Republic',
    alpha2: 'CZ',
    type: 'eu_vat',
    label: 'CZ VAT',
    exampleFormat: 'CZ1234567890',
    regex: /^CZ(\d{8,10})$/, // Looks for 'CZ' followed by 8 to 10 digits
  },
  {
    country: 'Denmark',
    alpha2: 'DK',
    type: 'eu_vat',
    label: 'DK VAT',
    exampleFormat: 'DK12345678',
    regex: /^DK(\d{8})$/, // Looks for 'DK' followed by 8 digits
  },
  {
    country: 'Dominican Republic',
    alpha2: 'DO',
    type: 'do_rcn',
    label: 'DO RCN',
    exampleFormat: '123-4567890-1',
    regex: /^(\d{3})\-(\d{7,9})\-(\d{1})$/, // Looks for 3 digits, a hyphen, 7 to 9 digits, another hyphen, and then 1 digit
  },
  {
    country: 'Ecuador',
    alpha2: 'EC',
    type: 'ec_ruc',
    label: 'EC RUC',
    exampleFormat: '1234567890001',
    regex: /^(\d{13})$/, // Looks for 13 digits
  },
  {
    country: 'Egypt',
    alpha2: 'EG',
    type: 'eg_tin',
    label: 'EG TIN',
    exampleFormat: '123456789',
    regex: /^(\d{9})$/, // Looks for 9 digits
  },
  {
    country: 'El Salvador',
    alpha2: 'SV',
    type: 'sv_nit',
    label: 'SV NIT',
    exampleFormat: '1234-567890-123-4',
    regex: /^(\d{4})\-(\d{6,9})\-(\d{3})\-(\d{1})$/, // Looks for 4 digits, a hyphen, 6 to 9 digits, another hyphen, 3 digits, another hyphen, and then 1 digit
  },
  {
    country: 'Estonia',
    alpha2: 'EE',
    type: 'eu_vat',
    label: 'EE VAT',
    exampleFormat: 'EE123456789',
    regex: /^EE(\d{9})$/, // Looks for 'EE' followed by 9 digits
  },
  {
    country: 'EU',
    alpha2: 'EU',
    type: 'eu_oss_vat',
    label: 'EU OSS VAT',
    exampleFormat: 'EU123456789',
    regex: /^EU(\d{9})$/, // Looks for 'EU' followed by 9 digits
  },
  {
    country: 'Finland',
    alpha2: 'FI',
    type: 'eu_vat',
    label: 'FI VAT',
    exampleFormat: 'FI12345678',
    regex: /^FI(\d{8})$/, // Looks for 'FI' followed by 8 digits
  },
  {
    country: 'France',
    alpha2: 'FR',
    type: 'eu_vat',
    label: 'FR VAT',
    exampleFormat: 'FRAB123456789',
    regex: /^FR[A-Z]{2}(\d{9})$/, // Looks for 'FR' followed by 2 uppercase letters and then 9 digits
  },
  {
    country: 'Georgia',
    alpha2: 'GE',
    type: 'ge_vat',
    label: 'GE VAT',
    exampleFormat: '123456789',
    regex: /^(\d{9})$/, // Looks for 9 digits
  },
  {
    country: 'Germany',
    alpha2: 'DE',
    type: 'eu_vat',
    label: 'DE VAT',
    exampleFormat: 'DE123456789',
    regex: /^DE(\d{9})$/, // Looks for 'DE' followed by 9 digits
  },
  {
    country: 'Greece',
    alpha2: 'GR',
    type: 'eu_vat',
    label: 'GR VAT',
    exampleFormat: 'EL123456789',
    regex: /^EL(\d{9})$/, // Looks for 'EL' followed by 9 digits
  },
  {
    country: 'Hong Kong',
    alpha2: 'HK',
    type: 'hk_br',
    label: 'HK BR',
    exampleFormat: '12345678',
    regex: /^(\d{8})$/, // Looks for 8 digits
  },
  {
    country: 'Hungary',
    alpha2: 'HU',
    type: 'eu_vat',
    label: 'HU VAT',
    exampleFormat: 'HU12345678',
    regex: /^HU(\d{8})$/, // Looks for 'HU' followed by 8 digits
  },
  {
    country: 'Hungary',
    alpha2: 'HU',
    type: 'hu_tin',
    label: 'HU TIN',
    exampleFormat: '12345678-1-23',
    regex: /^(\d{8})-?(\d{1})-?(\d{2})$/, // Looks for 8 digits, optional '-', 1 digit, optional '-', and 2 digits
  },
  {
    country: 'Iceland',
    alpha2: 'IS',
    type: 'is_vat',
    label: 'IS VAT',
    exampleFormat: '123456',
    regex: /^(\d{6})$/,
  }, // Looks for 6 digits
  {
    country: 'India',
    alpha2: 'IN',
    type: 'in_gst',
    label: 'IN GST',
    exampleFormat: '12ABCDE3456FGZH',
    regex: /^[0-9]{2}[A-Z]{5}\d{4}[A-Z][0-9A-Z]Z[0-9A-Z]$/, // Looks for 2 digits, 5 uppercase letters, 4 digits, an uppercase letter, 1 digit or uppercase letter, 'Z', and then 1 digit or uppercase letter
  },
  {
    country: 'Indonesia',
    alpha2: 'ID',
    type: 'id_npwp',
    label: 'ID NPWP',
    exampleFormat: '12.345.678.9-012.345',
    regex: /^(\d{2})\.(\d{3})\.(\d{3})\.(\d{1})\-(\d{3})\.(\d{3})$/, // Looks for 2 digits, a period, 3 digits, another period, 3 digits, another period, 1 digit, a hyphen, 3 digits, another period, and 3 digits
  },
  {
    country: 'Ireland',
    alpha2: 'IE',
    type: 'eu_vat',
    label: 'IE VAT',
    exampleFormat: 'IE1234567AB',
    regex: /^IE\d{6,7}[A-Za-z]{1,2}$/, // Looks for 'IE' followed by 6 or 7 digits and 1 or 2 letters
  },
  {
    country: 'Israel',
    alpha2: 'IL',
    type: 'il_vat',
    label: 'IL VAT',
    exampleFormat: '000012345',
    regex: /^(\d{9})$/, // Looks for 9 digits
  },
  {
    country: 'Italy',
    alpha2: 'IT',
    type: 'eu_vat',
    label: 'IT VAT',
    exampleFormat: 'IT12345678912',
    regex: /^IT(\d{11})$/, // Looks for 'IT' followed by 11 digits
  },
  {
    country: 'Japan',
    alpha2: 'JP',
    type: 'jp_cn',
    label: 'JP CN',
    exampleFormat: '1234567891234',
    regex: /^(\d{13})$/, // Looks for 13 digits
  },
  {
    country: 'Japan',
    alpha2: 'JP',
    type: 'jp_rn',
    label: 'JP RN',
    exampleFormat: '12345',
    regex: /^(\d{5})$/, // Looks for 5 digits
  },
  {
    country: 'Japan',
    alpha2: 'JP',
    type: 'jp_trn',
    label: 'JP TRN',
    exampleFormat: 'T1234567891234',
    regex: /^T(\d{13})$/, // Looks for 'T' followed by 13 digits
  },
  {
    country: 'Kenya',
    alpha2: 'KE',
    type: 'ke_pin',
    label: 'KE PIN',
    exampleFormat: 'P000111111A',
    regex: /^P(\d{9})[A-Z]$/, // Looks for 'P' followed by 9 digits and an uppercase letter
  },
  {
    country: 'Latvia',
    alpha2: 'LV',
    type: 'eu_vat',
    label: 'LV VAT',
    exampleFormat: 'LV12345678912',
    regex: /^LV(\d{11})$/, // Looks for 'LV' followed by 11 digits
  },
  {
    country: 'Liechtenstein',
    alpha2: 'LI',
    type: 'li_uid',
    label: 'LI UID',
    exampleFormat: 'CHE123456789',
    regex: /^CHE(\d{9})$/, // Looks for 'CHE' followed by 9 digits
  },
  {
    country: 'Lithuania',
    alpha2: 'LT',
    type: 'eu_vat',
    label: 'LT VAT',
    exampleFormat: 'LT123456789123',
    regex: /^LT(\d{12})$/, // Looks for 'LT' followed by 12 digits
  },
  {
    country: 'Luxembourg',
    alpha2: 'LU',
    type: 'eu_vat',
    label: 'LU VAT',
    exampleFormat: 'LU12345678',
    regex: /^LU(\d{8})$/, // Looks for 'LU' followed by 8 digits
  },
  {
    country: 'Malaysia',
    alpha2: 'MY',
    type: 'my_frp',
    label: 'MY FRP',
    exampleFormat: '12345678',
    regex: /^(\d{8})$/, // Looks for 8 digits
  },
  {
    country: 'Malaysia',
    alpha2: 'MY',
    type: 'my_itn',
    label: 'MY ITN',
    exampleFormat: 'C 1234567890',
    regex: /^C\s(\d{10})$/, // Looks for 'C ' followed by 10 digits
  },
  {
    country: 'Malaysia',
    alpha2: 'MY',
    type: 'my_sst',
    label: 'MY SST',
    exampleFormat: 'A12-3456-78912345',
    regex: /^A\d{2}-\d{4}-\d{8}$/, // Looks for 'A' followed by 2 digits, a hyphen, 4 digits, another hyphen, and then 8 digits
  },
  {
    country: 'Malta',
    alpha2: 'MT',
    type: 'eu_vat',
    label: 'MT VAT',
    exampleFormat: 'MT12345678',
    regex: /^MT(\d{8})$/, // Looks for 'MT' followed by 8 digits
  },
  {
    country: 'Mexico',
    alpha2: 'MX',
    type: 'mx_rfc',
    label: 'MX RFC',
    exampleFormat: 'ABC010203AB9',
    regex: /^[A-Z]{3}(\d{6})[A-Z0-9]{3}$/, // Looks for 3 uppercase letters, followed by 6 digits, and ending with 3 uppercase letters or digits
  },
  {
    country: 'Netherlands',
    alpha2: 'NL',
    type: 'eu_vat',
    label: 'NL VAT',
    exampleFormat: 'NL123456789B12',
    regex: /^NL(\d{9})B\d{2}$/, // Looks for 'NL' followed by 9 digits and 2 digits
  },
  {
    country: 'New Zealand',
    alpha2: 'NZ',
    type: 'nz_gst',
    label: 'NZ GST',
    exampleFormat: '123456789',
    regex: /^(\d{9})$/, // Looks for 9 digits
  },
  {
    country: 'Norway',
    alpha2: 'NO',
    type: 'no_vat',
    label: 'NO VAT',
    exampleFormat: '123456789MVA',
    regex: /^(\d{9})MVA$/, // Looks for 9 digits followed by 'MVA'
  },
  {
    country: 'Peru',
    alpha2: 'PE',
    type: 'pe_ruc',
    label: 'PE RUC',
    exampleFormat: '12345678901',
    regex: /^(\d{11})$/, // Looks for 11 digits
  },
  {
    country: 'Philippines',
    alpha2: 'PH',
    type: 'ph_tin',
    label: 'PH TIN',
    exampleFormat: '123456789012',
    regex: /^(\d{12})$/, // Looks for 12 digits
  },
  {
    country: 'Poland',
    alpha2: 'PL',
    type: 'eu_vat',
    label: 'PL VAT',
    exampleFormat: 'PL1234567890',
    regex: /^PL(\d{10})$/, // Looks for 'PL' followed by 10 digits
  },
  {
    country: 'Portugal',
    alpha2: 'PT',
    type: 'eu_vat',
    label: 'PT VAT',
    exampleFormat: 'PT123456789',
    regex: /^PT(\d{9})$/, // Looks for 'PT' followed by 9 digits
  },
  {
    country: 'Romania',
    alpha2: 'RO',
    type: 'eu_vat',
    label: 'RO VAT',
    exampleFormat: 'RO1234567891',
    regex: /^RO(\d{10})$/, // Looks for 'RO' followed by 10 digits
  },
  {
    country: 'Romania',
    alpha2: 'RO',
    type: 'ro_tin',
    label: 'RO TIN',
    exampleFormat: '1234567890123',
    regex: /^(\d{13})$/, // Looks for 13 digits
  },
  {
    country: 'Russia',
    alpha2: 'RU',
    type: 'ru_inn',
    label: 'RU INN',
    exampleFormat: '1234567891',
    regex: /^(\d{10})$/, // Looks for 10 digits
  },
  {
    country: 'Russia',
    alpha2: 'RU',
    type: 'ru_kpp',
    label: 'RU KPP',
    exampleFormat: '123456789',
    regex: /^(\d{9})$/, // Looks for 9 digits
  },
  {
    country: 'Saudi Arabia',
    alpha2: 'SA',
    type: 'sa_vat',
    label: 'SA VAT',
    exampleFormat: '123456789012345',
    regex: /^(\d{15})$/, // Looks for 15 digits
  },
  {
    country: 'Serbia',
    alpha2: 'RS',
    type: 'rs_pib',
    label: 'RS PIB',
    exampleFormat: '123456789',
    regex: /^(\d{9})$/, // Looks for 9 digits
  },
  {
    country: 'Singapore',
    alpha2: 'SG',
    type: 'sg_gst',
    label: 'SG GST',
    exampleFormat: 'M12345678X',
    regex: /^[A-Z](\d{8})[A-Z]$/, // Starts with a letter, followed by 8 digits, and ends with a letter
  },
  {
    country: 'Singapore',
    alpha2: 'SG',
    type: 'sg_uen',
    label: 'SG UEN',
    exampleFormat: '123456789F',
    regex: /^(\d{9})[A-Z]$/, // Starts with 9 digits and ends with a letter
  },
  {
    country: 'Slovakia',
    alpha2: 'SK',
    type: 'eu_vat',
    label: 'SK VAT',
    exampleFormat: 'SK1234567891',
    regex: /^SK(\d{10})$/, // Starts with 'SK' followed by 10 digits
  },
  {
    country: 'Slovenia',
    alpha2: 'SI',
    type: 'eu_vat',
    label: 'SI VAT',
    exampleFormat: 'SI12345678',
    regex: /^SI(\d{8})$/, // Starts with 'SI' followed by 8 digits
  },
  {
    country: 'Slovenia',
    alpha2: 'SI',
    type: 'si_tin',
    label: 'SI TIN',
    exampleFormat: '12345678',
    regex: /^(\d{8})$/, // Exactly 8 digits
  },
  {
    country: 'South Africa',
    alpha2: 'SA',
    type: 'za_vat',
    label: 'ZA VAT',
    exampleFormat: '4123456789',
    regex: /^(\d{10})$/, // Exactly 10 digits
  },
  {
    country: 'South Korea',
    alpha2: 'KR',
    type: 'kr_brn',
    label: 'KR BRN',
    exampleFormat: '123-45-67890',
    regex: /^(\d{3})\-(\d{2})\-(\d{5})$/, // Looks for 3 digits, a hyphen, 2 digits, another hyphen, and then 5 digits
  },
  {
    country: 'Spain',
    alpha2: 'ES',
    type: 'es_cif',
    label: 'ES CIF',
    exampleFormat: 'A12345678',
    regex: /^[A-Z](\d{8})$/, // Starts with an uppercase letter followed by 8 digits
  },
  {
    country: 'Spain',
    alpha2: 'ES',
    type: 'eu_vat',
    label: 'ES VAT',
    exampleFormat: 'ESA1234567Z',
    regex: /^ESA(\d{7}[A-Z])$/, // Starts with 'ESA' followed by 7 digits and an uppercase letter
  },
  {
    country: 'Sweden',
    alpha2: 'SE',
    type: 'eu_vat',
    label: 'SE VAT',
    exampleFormat: 'SE123456789123',
    regex: /^SE(\d{12})$/, // Starts with 'SI' followed by 8 digits
  },
  {
    country: 'Switzerland',
    alpha2: 'CH',
    type: 'ch_vat',
    label: 'CH VAT',
    exampleFormat: 'CHE-123.456.789 MWST',
    regex: /^CHE\-(\d{3})\.(\d{3})\.(\d{3})\sMWST$/, // Starts with 'CHE-', followed by 3 digits, a period, 3 digits, another period, 3 digits, a space, and then 'MWST'
  },
  {
    country: 'Taiwan',
    alpha2: 'TW',
    type: 'tw_vat',
    label: 'TW VAT',
    exampleFormat: '12345678',
    regex: /^(\d{8})$/, // Exactly 8 digits
  },
  {
    country: 'Thailand',
    alpha2: 'TH',
    type: 'th_vat',
    label: 'TH VAT',
    exampleFormat: '1234567891234',
    regex: /^(\d{13})$/, // Exactly 13 digits
  },
  {
    country: 'Turkey',
    alpha2: 'TR',
    type: 'tr_tin',
    label: 'TR TIN',
    exampleFormat: '0123456789',
    regex: /^(\d{10})$/, // Exactly 10 digits
  },
  {
    country: 'Ukraine',
    alpha2: 'UA',
    type: 'ua_vat',
    label: 'UA VAT',
    exampleFormat: '123456789',
    regex: /^(\d{9})$/, // Exactly 9 digits
  },
  {
    country: 'United Arab Emirates',
    alpha2: 'AE',
    type: 'ae_trn',
    label: 'AE TRN',
    exampleFormat: '123456789012345',
    regex: /^(\d{15})$/, // Exactly 15 digits
  },
  {
    country: 'United Kingdom',
    alpha2: 'UK',
    type: 'eu_vat',
    label: 'UK VAT',
    exampleFormat: 'XI123456789',
    regex: /^XI(\d{9})$/, // Starts with 'XI' followed by 9 digits
  },
  {
    country: 'United Kingdom',
    alpha2: 'UK',
    type: 'gb_vat',
    label: 'UK VAT',
    exampleFormat: 'GB123456789',
    regex: /^GB(\d{9})$/, // Starts with 'GB' followed by 9 digits
  },
  {
    country: 'United States',
    alpha2: 'US',
    type: 'us_ein',
    label: 'US EIN',
    exampleFormat: '12-3456789',
    regex: /^(\d{2})\-(\d{7})$/, // Looks for 2 digits, a hyphen, and then 7 digits
  },
  {
    country: 'Uruguay',
    alpha2: 'UY',
    type: 'uy_ruc',
    label: 'UY RUC',
    exampleFormat: '123456789012',
    regex: /^(\d{12})$/, // Exactly 12 digits
  },
  {
    country: 'Venezuela',
    alpha2: 'VE',
    type: 've_rif',
    label: 'VE RIF',
    exampleFormat: 'A-12345678-9',
    regex: /^([A-Z]{1})\-(\d{8})\-(\d)$/, // Looks for 1 digit, a hyphen, 8 digits, another hyphen, and then 1 digit
  },
  {
    country: 'Vietnam',
    alpha2: 'VN',
    type: 'vn_tin',
    label: 'VN TIN',
    exampleFormat: '1234567890',
    regex: /^(\d{10})$/, // Exactly 10 digits
  },
];

export function getTaxIdType(taxId, country) {
  const possibleTypes = taxIdTypes.filter(taxIdType => taxIdType.alpha2 === country);

  // the provided country doesn't have any tax id types
  if (possibleTypes.length === 0) {
    return {
      country: country,
      type: null,
      error: false,
    };
  }

  for (const entry of possibleTypes) {
    // if the entry has a regex, test the tax id against it
    if (entry.regex.test(taxId)) {
      return {
        country: country,
        type: entry.type,
        error: false,
      };
    }
  }

  // if there is no regex match, return null
  return {
    country: country,
    type: null,
    error: true,
    expectedFormats: possibleTypes.map(entry => entry.exampleFormat),
  };
}
